import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractButtonControl extends AbstractControl implements Control {

    protected button: FlexiButton;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.button = layer.getFlexiButton(assetName);

        this.button.on(ButtonEvent.CLICK, () => this.onClick());
    }

    public setVisible(visible: boolean) {
        this.button.setVisible(visible);
        super.setVisible(visible);
    }

    public setEnabled(enabled: boolean) {
        this.button.setEnabled(enabled);
        super.setEnabled(enabled);
    }

    public destroy() {
        this.button.destroy();
        super.destroy();
    }

    protected onClick() {
        // Button clicked
    }
}
